import { render, staticRenderFns } from "./DraftPriceFirm.vue?vue&type=template&id=580af502&"
import script from "./DraftPriceFirm.vue?vue&type=script&lang=js&"
export * from "./DraftPriceFirm.vue?vue&type=script&lang=js&"
import style0 from "./DraftPriceFirm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports